import { Text } from "@meditect/medibase-components";

export const SalesCannotEditDeletedSaleError = () => {
  return <Text>Cette vente a été supprimée : elle n'est plus modifiable.</Text>;
};
